var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 23,
    cy: 27,
    r: 1.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M24.6 20.4V6.8c0-.6-.3-1.1-.7-1.4-.4-.4-1-.6-1.7-.6-1.3 0-2.4.9-2.4 2v14.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M15.1 24.5V10.7c0-1.1 1-2 2.4-2 .7 0 1.2.2 1.7.6s.7.9.7 1.4v10.7M24.6 20.4V9.6c0-1.1 1.1-2 2.4-2 .7 0 1.2.2 1.7.6.3.3.6.8.6 1.4V20.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M32.8 32.5c.9-4.3 1.2-9.3 1.2-9.3v-7.8c0-.6-.3-1.1-.7-1.4-.4-.4-1-.6-1.7-.6-1.3 0-2.4.9-2.4 2v5.1M15.1 24.5l-1-1.4-1.1-1.7c-.4-.7-1.2-1.2-2.1-1.2-.3 0-.7.1-1 .2-1.2.5-1.7 1.7-1.1 2.7l4.2 7.7 2.1 3.9 2.5 3h13.6M24.6 20.4V6.8c0-.6-.3-1.1-.7-1.4-.4-.4-1-.6-1.7-.6-1.3 0-2.4.9-2.4 2v14.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M15.1 24.5V10.7c0-1.1 1-2 2.4-2 .7 0 1.2.2 1.7.6s.7.9.7 1.4v10.7M24.6 20.4V9.6c0-1.1 1.1-2 2.4-2 .7 0 1.2.2 1.7.6.3.3.6.8.6 1.4V20.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M32.8 32.5c.9-4.3 1.2-9.3 1.2-9.3v-7.8c0-.6-.3-1.1-.7-1.4-.4-.4-1-.6-1.7-.6-1.3 0-2.4.9-2.4 2v5.1M15.1 24.5l-1-1.4-1.1-1.7c-.4-.7-1.2-1.2-2.1-1.2-.3 0-.7.1-1 .2-1.2.5-1.7 1.7-1.1 2.7l4.2 7.7 2.1 3.9 2.5 3h13.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.3230214753035d6d039f51e42b2766f0.svg";
export { ForwardRef as ReactComponent };